import React from "react";
import './Business.css';
import { Link } from "react-router-dom";
import {
  Button,
  NavItem,
  NavLink,
  Nav,
} from "reactstrap";
import TranslateText from '../../translation/TranslateText'; // Adjust the import path as needed

export default function Footer() {
  return (
    <footer className="footer" style={{ backgroundColor: "black", padding: "30px 0", textAlign: "center" }}>
      <div className="headerParent">
        <div>
          <h1 className="footer-titles" style={{ fontSize: "24px", marginBottom: "20px"}}>
            <TranslateText text="• Pages •" />
          </h1>
        </div>
        <div>
          <h1 className="footer-titles" style={{ fontSize: "24px", marginBottom: "20px"}}>
            <TranslateText text="Follow us:" />
          </h1>
        </div>
        <div>
          <h1 className="footer-titles" style={{ fontSize: "24px", marginBottom: "20px"}}>
            <TranslateText text="Contact Info:" />
          </h1>
        </div>
        <div>
          <h1 className="footer-titles" style={{ fontSize: "24px", marginBottom: "20px"}}>
            <TranslateText text="Hours of Operation:" />
          </h1>
        </div>
      </div>

      <div className="parentBody">
        <div className="theChild theChild1">
          <Nav className="flex-column">
            <NavItem>
              <NavLink to="/" tag={Link} className="footer-pages">
                <TranslateText text="Home" />
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/packages" tag={Link}  className="footer-pages">
                <TranslateText text="Tradeline Packages" />
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/creditsweeps" tag={Link} className="footer-pages">
                <TranslateText text="Credit Sweeps" />
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/inquiryremoval" tag={Link} className="footer-pages">
                <TranslateText text="Inquiry Removal" />
              </NavLink>
            </NavItem>
          </Nav>
          <Nav className="flex-column">
            <NavItem>
              <NavLink to="/inventory" tag={Link} className="footer-pages">
                <TranslateText text="Tradeline Inventory" />
              </NavLink>
            </NavItem>
            {/* <NavItem>
              <NavLink to="/business" tag={Link} className="footer-pages">
                <TranslateText text="Business Credit Building" />
              </NavLink>
            </NavItem> */}
            <NavItem>
              <NavLink to="/support" tag={Link} className="footer-pages">
                <TranslateText text="Support Ticket" />
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink to="/FAQ" tag={Link} className="footer-pages">
                <TranslateText text="Tradeline FAQ's" />
              </NavLink>
            </NavItem>
          </Nav>
        </div>

        <div className="theChild theChild2">
          <div className="paul">
            <Button
              className="btn-icon btn-neutral btn-round btn-simple"
              color="default"
              to="https://www.facebook.com/profile.php?id=61552485815380"
              href="https://www.facebook.com/profile.php?id=61593626196611"

              id="tooltip230450801"
              target="_blank"
              style={{width: '100px', color: 'purple'}}
            >
              <i className="fab fa-facebook-square" />
            </Button>
          </div>

          <div className="paul">
            <Button
              className="btn-icon btn-neutral btn-round btn-simple"
              color="default"
              href="https://www.instagram.com/TradelineQueensusa"

              to="https://www.instagram.com/TradelineQueensusa"
              id="tooltip318450378"
              target="_blank"
              style={{width: '100px', color: 'purple'}}
            >
              <i className="fa-brands fa-instagram" />
            </Button>
          </div>

          <div className="paul">
            <Button
              className="btn-icon btn-neutral btn-round btn-simple"
              color="default"
              to=""
              id="tooltip622135962"
              target="_blank"
              style={{width: '100px', color: 'purple'}}
            >
              <i className="fa-brands fa-x-twitter" />
            </Button>
          </div>
        </div>
        
        <div className="theChild theChild3">
          <h5 className="staticWhite">Ariella@tradelinequeens.com</h5>
          <h5 className="staticWhite">Adiyah@tradelinequeens.com</h5>
          <h5 className="staticWhite">Spanish@tradelinequeens.com</h5>
          <h5 className="staticWhite">Businesscredit@tradelinequeens.com</h5>
          <h5 className="staticWhite">1-855-CLUB-850 / 1-855-258-2850</h5>

          <h5 className="staticWhite">
            <TranslateText text="Ext: 1 for Ariella" />
          </h5>
          <h5 className="staticWhite">
            <TranslateText text="Ext: 2 for Adiyah" />
          </h5>
          <h5 className="staticWhite">
            <TranslateText text="Ext: 3 for Spanish" />
          </h5>
        
        </div>
        
        <div className="theChild theChild4">
          <h5 className="staticWhite">
            <TranslateText text="Monday – Friday" />
          </h5>
          <h5 className="staticWhite">
            <TranslateText text="9:00am to 6:00pm (PST)" />
          </h5>
        </div>
      </div>
    </footer>
  );
}


// import React from "react";
// import './Business.css'
// import { Link } from "react-router-dom";
// // reactstrap components
// import {
//   Button,
//   NavItem,
//   NavLink,
//   Nav,
//   Container,
//   Row,
//   Col,
//   UncontrolledTooltip,
// } from "reactstrap";

// export default function Footer() {
//   return (
//     <footer className="footer" style={{ backgroundColor: "black", padding: "30px 0", textAlign: "center" }}>
          
//             <div className="headerParent">
//               <div>
//                 <h1 className="footer-titles" style={{ fontSize: "24px", marginBottom: "20px"}}>• Pages •</h1>
//               </div>
//               <div>
//                 <h1 className="footer-titles" style={{ fontSize: "24px", marginBottom: "20px"}}>Follow us:</h1>
//               </div>
//               <div>
//                 <h1 className="footer-titles" style={{ fontSize: "24px", marginBottom: "20px"}}>Contact Info</h1>
//               </div>
//                 <div>
//                 <h1 className="footer-titles" style={{ fontSize: "24px", marginBottom: "20px"}}>Hours of Operation</h1>
//                 </div>
//             </div>

            
//             <div className="parentBody">

//               <div className="theChild theChild1">
//                 <Nav className="flex-column">
//                   <NavItem>
//                     <NavLink to="/" tag={Link} className="footer-pages">
//                       Home
//                     </NavLink>
//                   </NavItem>
//                   <NavItem>
//                     <NavLink to="/landing-page" tag={Link} className="footer-pages">
//                       Tradeline Packages
//                     </NavLink>
//                   </NavItem>
//                   <NavItem>
//                     <NavLink to="/register-page" tag={Link} className="footer-pages">
//                       Credit Sweeps
//                     </NavLink>
//                   </NavItem>
//                   <NavItem>
//                     <NavLink to="/profile-page" tag={Link} className="footer-pages">
//                       Inquiry Removal
//                     </NavLink>
//                   </NavItem>
//                 </Nav>
//                 <Nav className="flex-column">
//                   <NavItem>
//                     <NavLink to="" className="footer-pages">
//                       Tradeline Inventory
//                     </NavLink>
//                   </NavItem>
//                   <NavItem>
//                     <NavLink to="" className="footer-pages">
//                       Business Credit Building
//                     </NavLink>
//                   </NavItem>
//                   <NavItem>
//                     <NavLink to="" className="footer-pages">
//                       Support Ticket
//                     </NavLink>
//                   </NavItem>
//                   <NavItem>
//                     <NavLink to="" className="footer-pages">
//                       Tradeline FAQ's
//                     </NavLink>
//                   </NavItem>
//                 </Nav>
//               </div>
              
                        
              
                        
//               <div className="theChild theChild2">
                
//                 <div className="paul">
//                   <Button
//                     className="btn-icon btn-neutral btn-round btn-simple"
//                     color="default"
//                     to="https://www.facebook.com/creativetim"
//                     id="tooltip230450801"
//                     target="_blank"
//                     style={{width: '100px', color: 'purple'}}
//                   >
//                     <i className="fab fa-facebook-square"/>
//                   </Button>
//                 </div>

//                 <div className="paul">
//                   <Button
//                     className="btn-icon btn-neutral btn-round btn-simple"
//                     color="default"
//                     to="https://www.instagram.com/TradelineQueensusa"
//                     id="tooltip318450378"
//                     target="_blank"
//                     style={{width: '100px', color: 'purple'}}
//                   >
//                     <i className="fa-brands fa-instagram" />
//                   </Button>
//                 </div>

//                 <div className="paul">
//                   <Button
//                     className="btn-icon btn-neutral btn-round btn-simple"
//                     color="default"
//                     to=""
//                     id="tooltip622135962"
//                     target="_blank"
//                     style={{width: '100px', color: 'purple',}}
//                   >
//                     <i className="fa-brands fa-x-twitter" />
//                   </Button>
//                 </div>
//               </div>
//                         <div className="theChild theChild3">
//                           <h5 className="staticWhite">Ariella@tradelinequeens.com</h5>
//                           <h5 className="staticWhite">Adiyah@tradelinequeens.com</h5>
//                           <h5 className="staticWhite">Spanish@tradelinequeens.com</h5>
//                           <h5 className="staticWhite">Businesscredit@tradelinequeens.com</h5>
//                           <h5 className="staticWhite">1-855-CLUB-850</h5>
//                           <h5 className="staticWhite">Ext: 1 for Ariella</h5>
//                           <h5 className="staticWhite">Ext: 2 for Adiyah</h5>
//                           <h5 className="staticWhite">Ext: 3 for Spanish</h5>
//                           <h5 className="staticWhite">Ext 4: Business Credit</h5>
//                         </div>
                        
//                         <div className="theChild theChild4">
//                           <h5 className="staticWhite">Monday – Friday</h5>
//                           <h5 className="staticWhite">9:00am to 6:00pm (PST)</h5>
//                         </div>
//             </div>
          
//     </footer>
//   );
// }
